/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/polo-history-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna a lista de alterações de polo realizadas na matrícula com polo anterior, novo polo, tipo de ação, data e responsável, para exibição na aba Histórico de Polo do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna o histórico de polo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/polo-history-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
